import { render, staticRenderFns } from "./EnterpriseBuildingInformation.vue?vue&type=template&id=05586aba&scoped=true&"
import script from "./EnterpriseBuildingInformation.vue?vue&type=script&lang=ts&"
export * from "./EnterpriseBuildingInformation.vue?vue&type=script&lang=ts&"
import style0 from "./EnterpriseBuildingInformation.vue?vue&type=style&index=0&id=05586aba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05586aba",
  null
  
)

export default component.exports